import React, { memo, useCallback } from 'react'

import { Toggle, Tooltip, Icon, InfoOutlined } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, func, bool } from 'prop-types'

import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

function ToggleSelector({
  id,
  keyName,
  sliceName,
  setFunction,
  label,
  disabled = false,
  tooltipMessage = undefined,
}) {
  const isActive = useThreeDStudioStore(
    (state) => state[sliceName]?.[keyName] ?? state[keyName]
  )

  const handleToggle = useCallback(() => {
    setFunction(!isActive)
  }, [isActive])

  const toggleComponent = (
    <Toggle
      id={id}
      label={label}
      className="model-settings__toggle"
      isChecked={isActive}
      onChange={handleToggle}
      disabled={disabled}
    />
  )

  if (tooltipMessage) {
    return (
      <div className="model-settings__toggle-container">
        {toggleComponent}
        <Tooltip
          id={`${id}-tooltip`}
          content={tooltipMessage}
          tooltipClassName="model-settings__tooltip"
        >
          <Icon svgComponent={InfoOutlined} color="darker" size="small" notSpaced />
        </Tooltip>
      </div>
    )
  }

  return toggleComponent
}

ToggleSelector.propTypes = {
  id: string.isRequired,
  keyName: string.isRequired,
  sliceName: string.isRequired,
  setFunction: func.isRequired,
  label: string.isRequired,
  disabled: bool,
  tooltipMessage: string,
}

export default memo(ToggleSelector)
